const designSystem = {
  gallery: "Gallery",
  components: "Components",
  handbook: "Handbook",
  searchComponents: "Search components...",
  filterByCategory: "Filter by category",
  allCategories: "All Categories",
  stable: "Stable",
  beta: "Beta",
  deprecated: "Deprecated",
  usedIn: "Used in",
  dependenciesLabel: "Dependencies",
  propsLabel: "Props",
  filePath: "File path",
  noResults: "No components found",
  totalComponents: "Total components",
  hasI18n: "i18n",
  hasCcId: "data-cc-id",
  catLayout: "Layout",
  catNavigation: "Navigation",
  catDataDisplay: "Data Display",
  catInput: "Input",
  catFeedback: "Feedback",
  catCanvas: "Canvas",
  catEditor: "Editor",
  catWidget: "Widget",
  registryOverview: "Registry Overview",
  conventions: "Conventions",
  componentAnatomy: "Component Anatomy",
  addingComponent: "Adding a Component",
  required: "Required",
  optional: "Optional",
  expandDetails: "Expand details",
  collapseDetails: "Collapse details",
  appPreview: "App Preview",
  previewDevice: "Device",
  previewPage: "Page",
  previewNote: "Read-only mobile preview. Interactive elements are disabled.",
  library: "Library",
  librarySearch: "Search components...",
  libraryAll: "All",
  libraryInstalled: "Installed only",
  libraryInstalledBadge: "Installed",
  libraryDocs: "Docs",
  libraryUse: "Use",
  libraryCopied: "Copied!",
  libraryShadcn: "shadcn/ui",
  libraryMagicUi: "Magic UI",
  library21st: "21st.dev",
  library21stNote: "21st.dev is search-based — 10 featured components shown here. For more, ask Claude to search 21st.dev.",
  librarySync: "Sync",
  libraryInstall: "Install",
  libraryPreview: "Preview",
  libraryRefreshTitle: "Refresh catalog via AI",
  // Design System page inline text
  previewLabel: "Preview",
  backToGallery: "Back to Gallery",
  openNewTab: "Open in new tab",
  openInTab: "Open in tab",
} as const;
export default designSystem;
